export default {"src":"/_next/static/media/homepage-door-handle.69d1463d.svg","height":480,"width":480,"blurWidth":0,"blurHeight":0};